<template>
  <div class="container2">
    <!-- 展商信息 -->
    <div class="row1">
      <div class="exhibitor">
        <div class="title">
          <h3>展商信息</h3>
          <button>编辑信息</button>
        </div>
        <div class="content">
          <div class="img">
            <img src="../../../static/production.png" alt="" />
          </div>
          <div class="detail">
            <p>中国煤炭工业国际技术咨询有限责任公司</p>
            <p>
              <span>展馆:<i style="color: #fdd000">E1</i></span
              ><span>展位号:<i style="color: #fdd000">E1.164</i></span>
            </p>
            <p><span>展位类型:12m²标准展位</span> <span>展位面积:12m²</span></p>
          </div>
        </div>
      </div>
      <div class="infor">
        <h3>数据统计</h3>
        <div class="shujv">
          <div class="box1">
            信息完善度
            <h2>30%</h2>
          </div>
          <div class="box1">
            已发布产品数
            <h2>5</h2>
          </div>

          <div class="box1">
            已发布现场活动
            <h2>3</h2>
          </div>
          <div class="box1">
            已上传直播活动
            <h2>1</h2>
          </div>
          <div class="box1">
            已预约观众
            <h2>0</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品中心 -->
    <div class="row2">
      <div class="title">
        <h3>产品中心</h3>
        <div class="button">
          <button class="all">查看全部</button>
          <button class="add">新增新闻</button>
        </div>
      </div>
      <div class="product">
        <div class="procuct_box" v-for="(item, index) in prodect" :key="index">
          <div class="img1">
            <img :src="item.imgurl" alt="" />
          </div>
          <h4>{{ item.pro_title }}</h4>
          <p>{{ item.pro_content }}</p>
        </div>
      </div>
    </div>
    <!-- 展商新闻 -->
    <div class="row3 row2">
      <div class="news">
        <div class="title">
          <h3>展商新闻</h3>
          <div class="button">
            <button class="all">查看全部</button>
            <button class="add">新增产品</button>
          </div>
        </div>
        <div class="news_content">
          <div class="news_box" v-for="(news, index) in news" :key="index">
            <p>
              {{ news.news_title }}
            </p>
            <p class="time">{{ news.news_day }}</p>
          </div>
        </div>
      </div>
      <div class="active">
        <div class="title">
          <h3>展商活动</h3>
          <div class="button">
            <button class="all">查看全部</button>
            <button class="add">新增活动</button>
          </div>
        </div>
        <div class="active_box">
          <div
            class="active_content"
            v-for="(item, index) in active"
            :key="index"
          >
            <div class="img">
              <img :src="item.imgurl" alt="" />
            </div>
            <p>靠得住的硬实力 山工机械新品发</p>
            <p>
              <img src="../../../static/ico_time.png" alt="" /><span>{{
                item.time
              }}</span>
            </p>
            <p>
              <img src="../../../static/ico_address.png" alt="" /><span>{{
                item.address
              }}</span
              >会议室
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 展商直播 -->
    <div class="row4 row2">
      <div class="live">
        <div class="title">
          <h3>展商直播</h3>
          <div class="button">
            <button class="all">查看全部</button>
            <button class="add">新增直播</button>
          </div>
        </div>
        <div class="active_box">
          <div
            class="active_content"
            v-for="(item, index) in live"
            :key="index"
          >
            <div class="img">
              <img :src="item.live_url" alt="" />
            </div>
            <p>{{ item.live_title }}</p>
            <p>
              <img src="../../../static/ico_time.png" alt="" /><span>{{
                item.live_day
              }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="mine">
        <div class="title">
          <h3>我的信息</h3>
          <div class="button">
            <button class="all">查看全部</button>
          </div>
        </div>
        <div class="xinxi" v-for="(item,index) in quiz" :key="index">
          <div class="name">
            <h4>{{item.name}}</h4>
            <p>{{item.time}}</p>
          </div>
          <p class="content">
            {{item.content}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //产品数据
      prodect: [
        {
          imgurl: require("@/static/tupian.png"),
          pro_title: "煤矿用液压锚杆钻车",
          pro_content: "系列化煤矿用液压锚杆钻车",
        },
        {
          imgurl: require("@/static/tupian.png"),
          pro_title: "煤矿用液压锚杆钻车",
          pro_content: "系列化煤矿用液压锚杆钻车",
        },
        {
          imgurl: require("@/static/tupian.png"),
          pro_title: "煤矿用液压锚杆钻车",
          pro_content: "系列化煤矿用液压锚杆钻车",
        },
        {
          imgurl: require("@/static/tupian.png"),
          pro_title: "煤矿用液压锚杆钻车",
          pro_content: "系列化煤矿用液压锚杆钻车",
        },
        {
          imgurl: require("@/static/tupian.png"),
          pro_title: "煤矿用液压锚杆钻车",
          pro_content: "系列化煤矿用液压锚杆钻车",
        },
      ],

      //新闻数据
      news: [
        {
          news_title:
            "北京市疾病预防控制中心关于对《第十九届中国国际煤炭采矿技术交流及设备展览会疫情防控工作",
          news_day: "2021-05-15",
        },
        {
          news_title: "严正声明",
          news_day: "2021-05-15",
        },
        {
          news_title: "2020煤炭行业十大新闻",
          news_day: "2021-05-15",
        },
        {
          news_title: "2020煤炭行业十大新闻",
          news_day: "2021-05-15",
        },
      ],
      //展商活动
      active: [
        {
          imgurl: require("@/static/tupian.png"),
          time: "2021年06月16日 14：00",
          address: "E2-202",
        },
        {
          imgurl: require("@/static/tupian.png"),
          time: "2021年06月16日 14：00",
          address: "E2-202",
        },
      ],
      //展商直播
      live: [
        {
          live_url: require("@/static/tupian.png"),
          live_title: "徐工基础直播活动标题",
          live_day: "2021年06月16日14：00",
        },
        {
          live_url: require("@/static/tupian.png"),
          live_title: "徐工基础直播活动标题",
          live_day: "2021年06月16日14：00",
        },
        {
          live_url: require("@/static/tupian.png"),
          live_title: "徐工基础直播活动标题",
          live_day: "2021年06月16日14：00",
        },
      ],
      //个人信息提问
      quiz:[
        {name:'小王',
        time:'2021-05-15',
        content:'你好！我是XXXX媒体记者，展会期间我们是否能对贵单位XXX领导进行企业专访？'
        },
        {name:'高小六',
        time:'2021-05-15',
        content:'您好，我是XXXXX公司采购负责人，想了解报名流程。'
        },
        {name:'赵四',
        time:'2021-05-15',
        content:'由中国煤炭工业协会主办、中国中煤能源集团有限公司协办，中国煤炭工业国际技术'
        },
      ]
    };
  },

  components: {},

  computed: {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.container2 {
  margin-left: 26px;
  margin-top: 17px;
  margin-right: 26px;
  background: #F0F2F5;
  // width: 1418px;
  // border: 1px solid red;

  .row1 {
    display: flex;
    height: 187px;
    .exhibitor {
      width: 688px;
      margin-right: 26px;
      box-sizing: border-box;
      padding: 17px 26px 26px 0;
      background:white ;
      // border: 1px solid red;
      .title {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0 9px 26px;
        border-bottom: 1px solid #e9e9e9;
        button {
          width: 76px;
          height: 28px;
          border: none;
          background: #006fb8;
          color: white;
          border-radius: 4px;
        }
      }
      .content {
        display: flex;
        height: 137px;
        box-sizing: border-box;
        padding: 17px 26px 25px;
        .img {
          width: 166px;
          height: 93px;
          text-align: center;
        }
        .detail {
          p:first-child {
            margin-bottom: 25px;
          }
          p:last-child {
            margin-top: 5px;
          }
          span {
            display: inline-block;
            width: 153px;
            font-size: 14px;
            margin-right: 40px;
            i {
              font-style: normal;
              font-size: 17px;
            }
          }
        }
      }
    }
    .infor {
      width: 706px;
      box-sizing: border-box;
      background: white;

      h3 {
        border-bottom: 1px solid #e9e9e9;
        box-sizing: border-box;
        padding: 18px 0 11px 26px;
      }
      .shujv {
        // border: 1px solid red;
        display: flex;
        height: 68px;
        width: 657px;
        margin: 44px 52px 34px 37px;
        justify-content: space-around;
        .box1 {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
          h2 {
            margin-top: 17px;
            font-size: 26px;
            font-family: HelveticaNeue-Medium, HelveticaNeue;
            font-weight: 500;
            color: #333333;
            line-height: 33px;
          }
        }
      }
    }
  }
  .row2 {
    box-sizing: border-box;
    padding: 0px 0 26px 0;
    margin-top: 26px;
    background: white;
    .title {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 15px 16px 9px 26px;
      border-bottom: 1px solid #e9e9e9;
      .button {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;
        .all {
          width: 76px;
          height: 28px;
          background: white;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
        }
        .add {
          width: 76px;
          height: 28px;
          background: #006fb8;
          border: none;
          margin-left: 9px;
          color: white;
          border-radius: 4px;
        }
      }
    }
    .product {
      display: flex;
      margin-left: 26px;
      .procuct_box {
        margin-right: 26px;
        margin-top: 27px;
        .img1 {
          width: 249px;
          height: 187px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        h4 {
          margin-top: 17px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 19px;
        }
        p {
          margin-top: 9px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 19px;
        }
      }
    }
  }

  .row3 {
    display: flex;
    background: #F0F2F5;
    // border: 1px solid red;
    .news {
      width: 800px;
      height: 345px;
      // border-bottom: 1px solid #e9e9e9;
      background: white;
      .news_box {
        display: flex;
        height: 45px;
        margin-left: 26px;
        line-height: 45px;
        p:first-child {
          width: 624px;
          font-size: 14px;
          overflow: hidden;
          font-weight: 500;
          color: #333333;
          font-family: PingFangSC-Medium, PingFang SC;
          margin-right: 56px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        p:last-child {
          font-size: 12px;
          font-weight: 400;
          width: 68px;
          color: #999999;
        }
      }
    }
    .active {
      width: 590px;
      height: 345px;
      margin-left: 26px;
      background: white;
      .active_box {
        margin: 17px 0 0 26px;
        display: flex;
        .active_content {
          width: 249px;
          margin-right: 26px;
          .img {
            img {
              width: 100%;
              height: 100%;
            }
          }
          p {
            width: 239px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 9px;
            span {
              color: #fdd000;
            }
            img {
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
  .row4 {
    display: flex;
    background: #F0F2F5;
    .live {
      width: 852px;
      background: white;
      .active_box {
        margin: 17px 0 0 26px;
        display: flex;
        .active_content {
          width: 249px;

          margin-right: 26px;
          .img {
            img {
              width: 100%;
              height: 100%;
            }
          }
          p:first-child {
          }
          p {
            width: 239px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 9px;
            span {
              color: #fdd000;
            }
            img {
              vertical-align: middle;
            }
          }
        }
      }
    }
    .mine {
      width: 539px;
      margin-left: 26px;
      background: white;
      .xinxi {
        box-sizing: border-box;
        padding: 13px 26px 0 0;
        margin-left: 26px;
        height: 73px;
        border-bottom: 1px solid #E9E9E9;
        .name {
          display: flex;
          justify-content: space-between;
          h4 {
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            margin-bottom: 9px;
          }
          p {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 19px;
          }
        }
        .content {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 19px;
          width: 443px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

        }
      }
    }
  }
}
</style>
